import { render, staticRenderFns } from "./checkupcar.vue?vue&type=template&id=72b60d5a"
import script from "./checkupcar.vue?vue&type=script&lang=js"
export * from "./checkupcar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports